import { useQuery, useMutation } from 'react-query'
import API from '.'

const ENDPOINT = '/api/whatsapp-config'
const QUERY_KEY = 'whatsapp-config'

export const useGetWhatsappConfigs = (config = {}) =>
  useQuery([QUERY_KEY], async () => (await API.get(ENDPOINT)).data, config)

export const usePostWhatsappConfig = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const useDeleteWhatsappConfig = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)
